module.exports = __webpack_public_path__ + "img/软件产品证书-存储设备定位追回系统V1.0.a84f8193.jpg";